<!-- 主计划选项 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form :formList="formList" @search="onSearch"></ls-search-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-if="$hasPermi(['fun_1833471642176671745_jfXBS'])">新建</a-button>
      <createModal ref="createModal" @finish="finish"></createModal>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="optionVersion"
          :scroll="{ fixScreen: true, x: 800 }"
        >
          <template slot="optionVersion" slot-scope="{text}">
            {{ text }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import CreateModal from './create-modal.vue'

import { generateLsTableResData } from '@/utils/util.js';
import { apiFindMpsFdOptions } from '@/api/finished-goods-order'
export default {
  // eslint-disable-next-line
  name: 'Master-plan-options', // name要和rms配置菜单路由保存一致
  components: {
    CreateModal
  },
  data () {
    return {
      warehouseOptions: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiFindMpsFdOptions, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        version: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formList: [
        {
          label: '版本',
          type: "globalSelect-selectSearch",
          decorator: ['version'],
          attrs: {
            placeholder: '请选择版本',
            requestApi: '/scp/scpMpsFdOptions/findOptionsVersionList',
            selectItem: { value: 'selectedValue', label: 'label' },
            searchParam: 'version'
          }
        }
      ],
      // 表格字段
      columns: [
        {
          title: '参数版本号',
          dataIndex: 'optionVersion',
          scopedSlots: { customRender: 'optionVersion' },
          align: 'center'
        },
        {
          title: '计划展望期',
          width: 220,
          dataIndex: 'planningHorizonDays',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '产品属性',
          dataIndex: 'itemAttributeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '包含值',
          dataIndex: 'includeValuesName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '一件代发',
          dataIndex: 'singleShipment',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    /**
     * 打开新建模态框
     * @param val
     */
    openCreateModal(val) {
      this.$refs.createModal.show(val)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('mdm/mdmUomConversions/export', {
        ...this.queryParams
      }, `标准单位转换_${new Date().getTime()}.xlsx`)
    },
    // 表单搜索
    onSearch (val) {
      this.queryParams = {};
      for(const key in val) {
        if(key !== 'searchFormLabel') {
          this.queryParams[key] = val[key]
        }
      }
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        version: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /**
     * 完成
     */
    finish() {
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
